import ru from './ru.json';
import en from './en.json';
const developerResources = {
    en,
    ru,
};
export { developerResources };
